import React from "react";
import { IStreetlightIconProps } from "../Icon.types";
import IconStyles from "../Icon.styles";
import theme from "../../../theme";

const COBRA_ICON: React.FC<IStreetlightIconProps> = (
  props: IStreetlightIconProps
) => {
  const { reported, className, type } = props;
  let { bgFill, fill } = props;

  if (!bgFill) {
    bgFill = reported
      ? theme.CE_THEME.colors.alerts.secondary
      : theme.CE_THEME.colors.brand.primary;
  }

  if (!fill) {
    fill = "#ffffff";
  }

  return (
    <IconStyles.StreetlightIcon
      id={`${type}`}
      className={`${className}`}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 360 360"
    >
      <circle fill={bgFill} cx="180" cy="180" r="180" />
      <g>
        <path
          className="light"
          stroke={fill}
          d="M127.917,317.63V129.821s0-28.588,24.872-44.636S222.347,42.37,222.347,42.37"
        />
        <path
          fill={fill}
          d="M157.64,100.885C168.8,119.421,194.8,124.2,215.715,111.558S244.55,73.643,233.4,55.107Z"
        />
      </g>
    </IconStyles.StreetlightIcon>
  );
};

export default COBRA_ICON;
